import { Transport } from "../../../common/model/transport.model";

export class TransportAssignmentSight {

  transportAssignmentId: number;
  executionTimestamp: string;;
  stationId: number;
  transport: Transport;

  constructor(transportAssignment?: Partial<TransportAssignmentSight>) {
    if (transportAssignment) {
      this.transportAssignmentId = transportAssignment.transportAssignmentId;
      this.executionTimestamp = transportAssignment.executionTimestamp;
      this.stationId = transportAssignment.stationId;
      if (transportAssignment.transport) {
        this.transport = new Transport(transportAssignment.transport);
      }
    }
  }

}

export class TransportAssignmentSelection {

  transportOptions = new Array<string>();
  stationSetIds = new Array<number>();

  constructor(selection: Partial<TransportAssignmentSelection>) {
    this.transportOptions = selection.transportOptions;
    this.stationSetIds = selection.stationSetIds;
  }
}
